import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: var(--radius-sm, 8px);
  border: 1px solid var(--glass-border);
  background: var(--glass-1);
  backdrop-filter: blur(10px);
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  color: var(--text-primary);
  font-size: 14px;
`;

const Th = styled.th`
  padding: 12px 16px;
  background: rgba(0,0,0,0.2);
  font-weight: 600;
  border-bottom: 2px solid var(--glass-border);
  color: var(--accent);
`;

const Td = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
`;

const Tr = styled.tr`
  &:last-child td {
    border-bottom: none;
  }
  &:hover td {
    background: var(--glass-2);
  }
`;

const TableWidget = ({ node, isLiveMode }) => {
  const tableDataRaw = node.content?.tableData || "Header1,Header2,Header3\nRow1-1,Row1-2,Row1-3\nRow2-1,Row2-2,Row2-3";
  const rows = tableDataRaw.split('\n').filter(r => r.trim() !== '');
  
  if(rows.length === 0) return <div>Leere Tabelle</div>;

  const headers = rows[0].split(',');
  const dataRows = rows.slice(1);

  return (
    <TableContainer>
      <StyledTable>
        <thead>
          <tr>
            {headers.map((h, i) => <Th key={i}>{h.trim()}</Th>)}
          </tr>
        </thead>
        <tbody>
          {dataRows.map((rowStr, i) => {
            const cols = rowStr.split(',');
            return (
              <Tr key={i}>
                {cols.map((col, j) => <Td key={j}>{col.trim()}</Td>)}
              </Tr>
            );
          })}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

registry.register('data_table', {
  label: 'Daten-Tabelle',
  icon: '🗄️',
  category: 'advanced',
  defaultContent: {
    tableData: "Feature,Basic,Pro\nSupport,Email,24/7\nStorage,10GB,100GB"
  },
  defaultStyle: {},
  render: TableWidget,
  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Tabellen-Daten (CSV-Format)',
          fields: [
            { name: 'content.tableData', label: 'Eingabe (Kommasepariert, Zeilen=Enter)', type: 'textarea' }
          ]
        }
      ]
    }
  ]
});
